module.exports = __webpack_public_path__ + "img/greybell.a483d3bf.svg";